var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var CommonUtils = require('../../utils/common-utils.js');
var DocumentsCollection = require('../../collections/documents-collection');
var OasisServices = require("../../data/oasis-services");

var OasisServicesValidatesView = require("../../views/oasis/oasis-services-validates-view");

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var utils = new CommonUtils();

var PatientDocumentsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/patient-documents-row.html'),

    ui: {
        checkBox: 'input[type=checkbox]'
    },

    events: {
        'change @ui.checkBox': 'onCheck'
    },

    downloadedAndPreviewedColor: '#337ab7',

    templateContext: function () {
        var that = this;
        var createdTime = that.model.get('createdTime');
        return {
            color: that.downloadedAndPreviewedColor,
            fmCreatedTime: createdTime != undefined && createdTime != '' && !isNaN(createdTime) ? utils.longToDateTimeFormatted(createdTime, 'MM/DD/YYYY') : '-',
            isOasisFile: that.isOasisFile(that.model)
        }
    },

    initialize: function (options) {
        var that = this;
    },

    onRender: function () {

    },

    isOasisFile: function (model) {
        var type = model.get('object').type || "";
        return type.toLowerCase() == "xml" || type.toLowerCase() == "txt";
    },

    onCheck: function (event) {
        if (event.target.checked) {
            this.triggerMethod("document:selected", {
                id: this.model.get("id"),
                name: this.model.get("name")
            });
        } else {
            this.triggerMethod("document:unselected", {
                id: this.model.get("id"),
                name: this.model.get("name")
            });
        }
    }
});


var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(4), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientDocumentsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientDocumentsRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {
        "document:selected": "onDocumentSelect",
        "document:unselected": "onDocumentUnselect"
    },

    initialize: function (options) {
        this.collection = options.collection;
    },

    childViewOptions: function () {
        return {};
    },

    onDocumentSelect: function (data) {
        this.triggerMethod("document:selected", data);
    },

    onDocumentUnselect: function (data) {
        this.triggerMethod("document:unselected", data);
    }
});

var PatientDocuments = Marionette.View.extend({
    template: require('../../templates/medicals/patient-documents.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
        oasisValidatingModal: "#oasis-validating-modal"
    },

    ui: {
        validateBtn: "#validate",
        applyBtn: '#apply-validates',
        oasisServiceInput: '.oasis-service'
    },

    events: {
        "click @ui.applyBtn": "onValidatesApply",
        'change @ui.oasisServiceInput': 'onOasisServiceSelected'
    },

    childViewEvents: {
        "document:selected": "onDocumentSelect",
        "document:unselected": "onDocumentUnselect"
    },

    templateContext: function () {
        var that = this;
        return {
            canEdit: that.canEdit,
            name: that.name,
            oasisServicesList: OasisServices.getServicesList()
        }
    },


    initialize: function (options) {
        //_.bindAll(this, 'onRender', 'showLoading', 'hideLoading', 'logError');
        this.medProfileModel = options.medProfileModel;
        this.name = options.name;
        var personId = this.medProfileModel.get('object').personId;
        this.documentsCollection = new DocumentsCollection([], {
            params: [
                {key: 'sortby', value: 'createdTime'},
                {key: 'sortdir', value: 'DESC'},
                {key: 'object_patientId', value: personId}
            ]
        });

        this.selectedDocumentsIdNames = [];
        this.selectedOasisServices = [];
    },

    onRender: function () {
        var that = this;
        that.showLoading();
        that.documentsCollection.fetch({
            success: function () {
                that.showChildView('body', new PatientDocumentsTableBody({
                    collection: that.documentsCollection
                }));
                that.hideLoading();
            },
            error: function (e) {
                that.logError(e);
            }
        });

        that.ui.validateBtn.attr("disabled", true);
        that.ui.applyBtn.addClass("disabled");
    },

    onDocumentSelect: function (data) {
        this.selectedDocumentsIdNames.push(data);
        this.changeValidateBtnAccess(this.selectedDocumentsIdNames);
    },

    onDocumentUnselect: function (data) {
        this.selectedDocumentsIdNames = _.reject(this.selectedDocumentsIdNames, function (item) {
            return item.id == data.id && item.name == data.name;
        });
        this.changeValidateBtnAccess(this.selectedDocumentsIdNames);
    },

    changeValidateBtnAccess: function (selectedDocumentsIdNames) {
        if (selectedDocumentsIdNames.length == 0)
            this.ui.validateBtn.attr("disabled", true);
        else
            this.ui.validateBtn.removeAttr("disabled");
    },

    onOasisServiceSelected: function (event) {
        var checked = event.target.checked;
        var oasisServiceId = event.target.id;

        if (checked) {
            this.selectedOasisServices.push(oasisServiceId);
        } else {

            this.selectedOasisServices = _.reject(this.selectedOasisServices, function (id) {
                return id == oasisServiceId;
            });
        }

        if (this.selectedOasisServices.length == 0) {
            this.ui.applyBtn.addClass("disabled");
        } else {
            this.ui.applyBtn.removeClass("disabled");
        }
    },

    onValidatesApply: function () {
        this.showChildView("oasisValidatingModal", new OasisServicesValidatesView({
            oasisServicesIds: this.selectedOasisServices,
            documents: this.selectedDocumentsIdNames
        }));
    },

    showLoading: function () {
        utils.showSpinner();
    },

    hideLoading: function () {
        utils.hideSpinner();
    },

    logError: function (error) {
        utils.hideSpinner();
        notificationsChannel.request('show:notification', JSON.parse(error));
    }

});

module.exports = PatientDocuments;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/patient-documents-view.js
// module id = 364
// module chunks = 0